import { render, staticRenderFns } from "./newSystem.vue?vue&type=template&id=5c3764e5&scoped=true"
import script from "./newSystem.vue?vue&type=script&lang=js"
export * from "./newSystem.vue?vue&type=script&lang=js"
import style0 from "./newSystem.vue?vue&type=style&index=0&id=5c3764e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3764e5",
  null
  
)

export default component.exports